import { ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  visible: boolean;
  onClick: () => void;
};

/**
 * Floating "jump to latest" control for auto-scrolling lists. Must be placed
 * inside a `relative` wrapper around the scroll container.
 */
const JumpToLatestButton = ({ visible, onClick }: Props) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Jump to latest"
    title="Jump to latest"
    tabIndex={visible ? 0 : -1}
    aria-hidden={!visible}
    className={cn(
      "absolute bottom-2 left-1/2 z-10 grid h-8 w-8 -translate-x-1/2 place-items-center rounded-full border border-white/10 bg-slate-800/90 text-slate-200 shadow-lg backdrop-blur transition-all duration-200 hover:bg-slate-700 hover:text-white",
      visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"
    )}
  >
    <ArrowDown className="h-4 w-4" />
  </button>
);

export default JumpToLatestButton;
